const clickDownloadLink = (url: string, name: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadDocumentFromUrl = async (
  url: string,
  name = "document",
) => {
  const downloadName = name?.trim() || "document";

  try {
    if (url?.toString()?.includes("headcargo")) {
      clickDownloadLink(url, downloadName);
      return;
    }
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Download failed with status ${response.status}`);
    }

    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);

    clickDownloadLink(objectUrl, downloadName);
    window.URL.revokeObjectURL(objectUrl);
  } catch {
    clickDownloadLink(url, downloadName);
  }
};
